export const getAdminMenuItems = () => [
  { path: '/admin', icon: 'fa-home', label: 'Dashboard' },
  {
    label: 'Data Management',
    icon: 'fa-database',
    items: [
      { path: '/admin/data', icon: 'fa-list', label: 'Daftar Data' },
      { path: '/admin/verified', icon: 'fa-check-circle', label: 'Data Terintegrasi' },
      { path: '/admin/published', icon: 'fa-globe', label: 'Data Terpublikasi' }
    ]
  },
  {
    label: 'Management Aplikasi',
    icon: 'fa-cog',
    items: [
      { path: '/management/data', icon: 'fa-database', label: 'Pengelolaan Data' },
      { path: '/management/users', icon: 'fa-users', label: 'Pengelolaan Pengguna' },
      { path: '/management/catalog', icon: 'fa-book', label: 'Katalog Metadata' }
    ]
  },
  { path: '/profile', icon: 'fa-user', label: 'Profile' }
];

export const getKLMenuItems = () => [
  { path: '/kl', icon: 'fa-home', label: 'Dashboard' },
  { path: '/kl/upload', icon: 'fa-upload', label: 'Upload Data' },
  { path: '/kl/data', icon: 'fa-list', label: 'Daftar Data' },
  { path: '/profile', icon: 'fa-user', label: 'Profile' }
];

export const getSupervisorMenuItems = () => [
  { path: '/admin', icon: 'fa-home', label: 'Dashboard' },
  {
    label: 'Data Management',
    icon: 'fa-database',
    items: [
      { path: '/admin/data', icon: 'fa-list', label: 'Daftar Data' },
      { path: '/admin/verified', icon: 'fa-check-circle', label: 'Data Terintegrasi' },
      { path: '/admin/published', icon: 'fa-globe', label: 'Data Terpublikasi' }
    ]
  },
  {
    label: 'Management Aplikasi',
    icon: 'fa-cog',
    items: [
      { path: '/management/data', icon: 'fa-database', label: 'Pengelolaan Data' },
      { path: '/management/users', icon: 'fa-users', label: 'Pengelolaan Pengguna' },
      { path: '/management/catalog', icon: 'fa-book', label: 'Katalog Metadata' }
    ]
  },
  { path: '/profile', icon: 'fa-user', label: 'Profile' }
];

export const getPublikatorMenuItems = () => [
  { path: '/publikator', icon: 'fa-home', label: 'Dashboard' },
  { path: '/publikator/data', icon: 'fa-newspaper', label: 'Publikasi Data' },
  { path: '/publikator/history', icon: 'fa-history', label: 'History Data' },
  { path: '/publikator/catalog', icon: 'fa-book', label: 'Katalog Metadata' },
  { path: '/profile', icon: 'fa-user', label: 'Profile' }
];

export const getMenuItemsByRole = (role) => {
  switch (role) {
    case 0:
    case 2:
      return role === 0 ? getAdminMenuItems() : getSupervisorMenuItems();
    case 1:
      return getKLMenuItems();
    case 3:
      return getPublikatorMenuItems();
    default:
      return [];
  }
};
